import React from 'react';
import './PriceBenefits.css';

// Import the new image
import meetingImage from '../../assets/images/business-meeting.jpg';

const PriceBenefits = () => {
  return (
    <section className="price-benefits-section">
      <div className="benefits-container">
        {/* Left Column: Image */}
        <div className="benefits-image-col">
          <img src={meetingImage} alt="Business meeting discussing prices" />
        </div>

        {/* Right Column: Text Content */}
        <div className="benefits-text-col">
          <div className="section-header">
            <h2>How our prices help your business</h2>
          </div>
          <p>
            CRISHI's price indices help you make faster, smarter decisions. Use them to settle contracts fairly, benchmark deals confidently, and manage risk in volatile markets.
          </p>
          <p>
            They're also trusted during audits and arbitration, offering reliable, independent data when it matters most.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PriceBenefits;